import Settings from './Setting';
import CommonReducer from './CommonReducer';
import Auth from './Auth';
import CurrLoc from './CurrLoc';
import Dashboard from './Dashboard';
import Ecommerce from './Ecommerce';
import UserList from './UserList';
import LocList from './LocList';

const reducers = {
  settings: Settings,
  auth: Auth,
  currLoc: CurrLoc,
  dashboard: Dashboard,
  ecommerce: Ecommerce,
  common: CommonReducer,
  userList: UserList,
  locList: LocList,
};

export default reducers;
